module.exports = __webpack_public_path__ + "static/img/lange_crub_1.a12b8728.jpg";